var map = {
	"./address/index.js": 919,
	"./breadcrumbs/index.js": 920,
	"./cart/index.js": 921,
	"./categories/index.js": 922,
	"./checkout/index.js": 925,
	"./cms/index.js": 1012,
	"./delivery/index.js": 1013,
	"./header/index.js": 1014,
	"./main-content/index.js": 1015,
	"./modal/index.js": 1016,
	"./mymigros/index.js": 1017,
	"./navigator/index.js": 1018,
	"./notifications/index.js": 1019,
	"./orders/index.js": 1020,
	"./panel/index.js": 1022,
	"./pickers/index.js": 1023,
	"./poll/index.js": 1024,
	"./product/index.js": 1025,
	"./products/index.js": 1026,
	"./region/index.js": 1027,
	"./router/index.js": 1028,
	"./scroll/index.js": 1030,
	"./search/index.js": 1032,
	"./snackbar/index.js": 1033,
	"./stripe/index.js": 1034,
	"./subscription/index.js": 1035,
	"./tooltip/index.js": 1036,
	"./top-products/index.js": 1037,
	"./user/index.js": 1038,
	"./video-cards/index.js": 1039,
	"./viewport/index.js": 1040
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 918;


//////////////////
// WEBPACK FOOTER
// ./mcart/assets/src/js/app/reducers/modules index\.js$
// module id = 918
// module chunks = 2